import { type MaybeRefOrGetter, toValue } from 'vue'
import { approveInvoice } from '@/features/invoices/api/approve-invoice'
import { cancelInvoice } from '@/features/invoices/api/cancel-invoice'
import { useMutationWithInvalidation } from '@/shared/composables/useMutationWithInvalidation'
import { invoiceQueryKeys } from '@/features/invoices/query-keys'
import { createWheelingInvoice } from '../api/create-invoice'
import type { createWheelingInvoiceSchema } from '../schemas'
import { z } from 'zod'

export const useApproveInvoice = () => useMutationWithInvalidation({
  mutationFn: (invoiceId: MaybeRefOrGetter<number>) => approveInvoice(toValue(invoiceId)),
}, [
  (invoiceId) => invoiceQueryKeys.activityLog(invoiceId),
  (invoiceId) => invoiceQueryKeys.details(invoiceId),
  invoiceQueryKeys.paginated(),
  ['invoices:list'],
  (invoiceId) => ['invoices', invoiceId],
])

export const useCancelInvoice = () => useMutationWithInvalidation({
  mutationFn: (invoiceId: MaybeRefOrGetter<number>) => cancelInvoice(toValue(invoiceId))
}, [
  (invoiceId) => invoiceQueryKeys.activityLog(invoiceId),
  (invoiceId) => invoiceQueryKeys.details(invoiceId),
  invoiceQueryKeys.paginated(),
  ['invoices:list'],
  (invoiceId) => ['invoices', invoiceId],
])

export const useCreateWheelingInvoice = () => useMutationWithInvalidation({
  mutationFn: (input: z.infer<typeof createWheelingInvoiceSchema>) => createWheelingInvoice(input)
}, [
  invoiceQueryKeys.paginated(),
  ['invoice:list']
])
